// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"6527":"7204cca3","6891":"d7f4c2a1"}[chunkId] + ".css";
};